function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultSchema = {
  reflexAttribute: 'data-reflex',
  reflexPermanentAttribute: 'data-reflex-permanent',
  reflexRootAttribute: 'data-reflex-root',
  reflexDatasetAttribute: 'data-reflex-dataset',
  reflexDatasetAllAttribute: 'data-reflex-dataset-all',
  reflexSerializeFormAttribute: 'data-reflex-serialize-form',
  reflexFormSelectorAttribute: 'data-reflex-form-selector',
  reflexIncludeInnerHtmlAttribute: 'data-reflex-include-inner-html',
  reflexIncludeTextContentAttribute: 'data-reflex-include-text-content'
};
var schema = {};
export default {
  set: function set(application) {
    var _this = this;

    schema = _objectSpread(_objectSpread({}, defaultSchema), application.schema);

    var _loop = function _loop(attribute) {
      Object.defineProperty(_this, attribute.slice(0, -9), {
        get: function get() {
          return schema[attribute];
        }
      });
    };

    for (var attribute in schema) {
      _loop(attribute);
    }
  }
};